const QuestionTypes = {
  INTEGER_VALUE: "integerValue",
  SINGLE_TEXT_VALUE: "singleTextValue",
  MULTIPLE_TEXT_VALUE: "multipleTextValue"
} as const;

const ALL = Object.values(QuestionTypes);

export default { ...QuestionTypes, ALL };
